<div class="panel rs-bg-grey1">
  <h3 class="rs-tit6">{{ 'digitalis.websiteOptions.title' | translate }}</h3>
  <div class="rs-flex-row" role="list">
    <mprd-option
      class="rs-flex-columns small-12 medium-6"
      role="listitem"
      *ngFor="let option of options | excludeFilter: 'optionCodeForDescription':'CIYCV'"
      [option]="option"
      [product]="selectedProduct"
    ></mprd-option>
  </div>
</div>
